import {Box, Grid, Typography} from '@material-ui/core'
import {Loader} from 'lib/ui/Loader'
import Center from 'lib/ui/layout/Center'
import {ceil} from 'lodash'
import React from 'react'

export type BroadcastEmailStatistic = {
  num_sent: number
  num_opened: number
  num_clicked: number
  num_complaints: number
  num_bounced: number
}

export function StatisticsForEmailBroadcast(props: {
  statistics: BroadcastEmailStatistic | null
}) {
  const statistics = props.statistics

  if (!statistics) {
    return (
      <Box p={4}>
        <Center>
          <Loader />
        </Center>
      </Box>
    )
  }

  const getPercents = (number: number) => {
    return ceil((number / statistics.num_sent) * 100) || 0
  }

  return (
    <Box minWidth={120} maxWidth={300} p={2}>
      <Grid container>
        <Grid item xs={8}>
          Total Sent:
        </Grid>
        <Grid item xs={4}>
          <Typography
            align="right"
            aria-label={`totalsend:${statistics.num_sent}`}
          >
            {statistics.num_sent}
          </Typography>
        </Grid>
        <Grid item xs={8}>
          Total Opened:
        </Grid>
        <Grid item xs={4}>
          <Typography
            align="right"
            aria-label={`totalopened:${statistics.num_opened}`}
          >
            {statistics.num_opened} ({getPercents(statistics.num_opened)}%)
          </Typography>
        </Grid>

        <Grid item xs={8}>
          Total Clicked:
        </Grid>
        <Grid item xs={4}>
          <Typography
            align="right"
            aria-label={`totalclicked:${statistics.num_clicked}`}
          >
            {statistics.num_clicked} ({getPercents(statistics.num_clicked)}%)
          </Typography>
        </Grid>

        <Grid item xs={8}>
          Total Complaints:
        </Grid>
        <Grid item xs={4}>
          <Typography
            align="right"
            aria-label={`totalcomplaints:${statistics.num_complaints}`}
          >
            {statistics.num_complaints} (
            {getPercents(statistics.num_complaints)}%)
          </Typography>
        </Grid>

        <Grid item xs={8}>
          Total Bounced:
        </Grid>
        <Grid item xs={4}>
          <Typography
            align="right"
            aria-label={`totalbounced:${statistics.num_bounced}`}
          >
            {statistics.num_bounced} ({getPercents(statistics.num_bounced)}%)
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}
